import { batchInfo } from "@/lib/apiClient/client.ts"
import { BaseDiffViewModel } from "@/routes/tasks/TaskViewScene/BaseDiffViewModel.ts"

import type { GitCommitChange, TID } from "@/lib/client/generated/TypeDefinitions.ts"
import type { GlobalContext } from "@/lib/context.ts"
import type { Queries } from "@/lib/queries.ts"
import type { TaskViewModel } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"


export class TaskChangesModel extends BaseDiffViewModel {
  constructor(
    protected readonly model: TaskViewModel,
    protected readonly context: GlobalContext,
    protected readonly queries: Queries,
  ) {
    super("TaskChangesModel")
  }

  downloadPatch(): void {
    this.queries.apiClient.downloadPatch(this.model.taskId as TID)
  }

  protected async fetchChanges(): Promise<GitCommitChange[]> {
    const task = this.model.task.get()
    if (!task) throw new Error("Task is not ready")

    const commits: string[] = []
    const historyItems = this.model.historyItems.get()

    for (const item of historyItems) {
      if (!item.isActive) break
      if (item.number !== 0) {
        commits.push(item.commit.id)
      }
    }

    return await this.queries.getCommitChanges(batchInfo(100), this.model.project.get().key, this.model.repositoryName, commits)
  }
}
